import { retrieve, update } from "framework/http/endpoint";
import { createCollectionResponseFactory, createEntityResponseFactory } from "framework/http/rest/jsonResponse";
import { fromApiTransportDate } from "framework/http/transport";
import { UrlPathOfApiLocation } from "common/paths";
var ApiUriPrefix = "".concat(UrlPathOfApiLocation, "/api/1/ranklist");
function apiGetRanklists() {
    var uri = ApiUriPrefix;
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportRanklist));
}
function apiGetRanklist(ranklistId) {
    var uri = "".concat(ApiUriPrefix, "/").concat(ranklistId);
    return retrieve(uri, null, createEntityResponseFactory(fromTransportRanklist));
}
function apiPublishRanklist(ranklistId) {
    var uri = "".concat(ApiUriPrefix, "/").concat(ranklistId, "/publish");
    return update(uri, null, createEntityResponseFactory(fromTransportRanklist));
}
function apiHideRanklist(ranklistId) {
    var uri = "".concat(ApiUriPrefix, "/").concat(ranklistId, "/hide");
    return update(uri, null, createEntityResponseFactory(fromTransportRanklist));
}
function apiRecalculateRanklist(ranklistId) {
    var uri = "".concat(ApiUriPrefix, "/").concat(ranklistId, "/recalculate");
    return update(uri, null, createEntityResponseFactory(fromTransportRanklist));
}
function fromTransportRanklist(entity) {
    var _a;
    entity.date = fromApiTransportDate(entity.date);
    (_a = entity.competitors) === null || _a === void 0 ? void 0 : _a.forEach(function (c) {
        c.events.forEach(function (e) {
            e.date = fromApiTransportDate(e.date);
        });
    });
    return entity;
}
export { apiGetRanklists, apiGetRanklist, apiPublishRanklist, apiHideRanklist, apiRecalculateRanklist, };
